import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-terms-of-sale',
  templateUrl: './general-terms-of-sale.component.html',
  styleUrls: ['./general-terms-of-sale.component.css']
})
export class GeneralTermsOfSaleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
